import { useState, useCallback } from 'react';

const requestStatus = {
    IDLE: 'IDLE',
    PENDING: 'PENDING',
    REJECTED: 'REJECTED',
    FULFILLED: 'FULFILLED',
};
const useRequestStatus = () => {
    const [status, setRequestStatus] = useState(requestStatus.IDLE);
    return {
        setStatusIdle: useCallback(() => setRequestStatus(requestStatus.IDLE), []),
        setStatusPending: useCallback(() => setRequestStatus(requestStatus.PENDING), []),
        setStatusFulfilled: useCallback(() => setRequestStatus(requestStatus.FULFILLED), []),
        setStatusRejected: useCallback(() => setRequestStatus(requestStatus.REJECTED), []),
        isStatusIdle: status === requestStatus.IDLE,
        isStatusPending: status === requestStatus.PENDING,
        isStatusFulfilled: status === requestStatus.FULFILLED,
        isStatusRejected: status === requestStatus.REJECTED,
    };
};

export { requestStatus, useRequestStatus };
//# sourceMappingURL=useRequestStatus.js.map
